export const WORKSPACE_LINE_PLOT_SETTINGS_DESCRIPTION =
  'Apply settings to all line plots in this workspace.';

export const SECTION_LINE_PLOT_SETTINGS_DESCRIPTION =
  'Apply settings to all line plots in this section.';

export const WORKSPACE_SEMANTIC_LEGENDS_SETTINGS_DESCRIPTION =
  'Customize run display in this workspace.';
